import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../../Context/AuthContext';


const useEditTruck = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  const editTruck = useMutation(
    async ({ id, formData }) => { 
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/freight/update-trucks/${id}`, {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData), 
      });

      if (!response.ok) {
        throw new Error('Failed to Edit Truck');
      }

      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('freighttruck');
        queryClient.invalidateQueries('trucksDetails');
      },
    }
  );

  return {
    editTruck,
    isLoading: editTruck.isLoading,
    error: editTruck.error,
  };
};

export default useEditTruck;
